import React, { useState } from 'react';
import theme from 'theme/theme';
import PropTypes from 'prop-types';
import { InputContainer, StyledInput, StyledTextArea, Label } from './styled';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

const TextInput = ({
	width = '100%',
	type,
	label,
	disabled,
	onBlur,
	error,
	color,
	textarea = false,
	maxLength,
	visible = false,
	...rest
}) => {
	const [showPassword, setShowPassword] = useState(false);
	const getType = () => {
		if (visible) {
			if (showPassword) {
				return 'text';
			}
		}
		return type;
	};

	return (
		<div style={{ display: 'inline-block', width: width }}>
			{label ? <Label>{label}</Label> : null}
			<InputContainer
				textarea={textarea}
				style={{
					padding: disabled ? '5px 0 5px 15px' : '5px 15px',
					backgroundColor: color || theme.background2,
					border: error && `1px solid ${theme.danger}`,
					display: visible && 'flex',
					justifyContent: visible && 'space-between',
				}}
				onBlur={onBlur || null}>
				{textarea ? (
					<StyledTextArea {...rest} maxLength={maxLength || 200} />
				) : (
					<>
						<StyledInput
							id='txt-input'
							{...rest}
							type={getType() || 'text'}
							readOnly={disabled}
							onBlur={onBlur || null}
							style={{
								width: visible ? 'calc(100% - 30px)' : '100%',
							}}
						/>
						{visible && (
							<>
								{showPassword ? (
									<VisibilityOffIcon
										onClick={() => setShowPassword(false)}
									/>
								) : (
									<VisibilityIcon
										onClick={() => setShowPassword(true)}
									/>
								)}
							</>
						)}
					</>
				)}
			</InputContainer>
			{error ? (
				<p
					style={{
						color: theme.danger,
						fontSize: '12px',
						marginBottom: 0,
						marginTop: '5px',
						maxWidth: width,
					}}>
					{' '}
					{error}
				</p>
			) : null}
		</div>
	);
};

TextInput.propTypes = {
	width: PropTypes.string,
	type: PropTypes.string,
	label: PropTypes.string,
	disabled: PropTypes.bool,
	onBlur: PropTypes.func,
	error: PropTypes.string,
	textarea: PropTypes.bool,
	maxLength: PropTypes.number,
	visible: PropTypes.bool,
};

TextInput.defaultProps = {
	width: '100%',
	type: 'text',
	label: '',
	disabled: false,
	onBlur: null,
	error: '',
	textarea: false,
	maxLength: 200,
	visible: false,
};

export default TextInput;
